import request from '@/config/axios'

export const getMatchPushPage = (params: any) =>
  request.get({ url: '/bosscircle/match-push/page', params })
export const getMatchPushStats = (params: any) =>
  request.get({ url: '/bosscircle/match-push/stats', params })
